import { type FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { useCountDownTimer } from '@/common/hooks/count-down-timer';
import { milisecondsToTime } from '@/common/lib/timer';
import { H1, StringXSmall } from '@/components/Typography/Typography';

import css from './styles.module.scss';

interface TimerProps {
  timeToEnd: number;
}

const Timer: FC<TimerProps> = ({ timeToEnd }) => {
  const { t } = useTranslation();
  const seconds = useCountDownTimer(timeToEnd < 0 ? 0 : timeToEnd);
  const timeObj = milisecondsToTime(seconds * 1000);
  const timerStructureArray = [
    {
      key: 'days',
      text: 'days',
    },
    { key: '1', text: '' },
    {
      key: 'hours',
      text: 'hours',
    },
    { key: '2', text: '' },
    {
      key: 'minutes',
      text: 'min',
    },
    { key: '3', text: '' },
    { key: 'seconds', text: 'sec' },
  ];

  return (
    <div className="flex py-2 px-6 rounded-[500px] bg-[#1D1F25]/60 gap-2">
      {timerStructureArray.map(({ key, text }, index) => (
        <div
          className={cn('flex flex-col items-center gap-1', text && 'w-12')}
          key={index}
        >
          <H1 weight="bold" className={cn('!text-accent', css.timerText)}>
            {text ? timeObj[key as keyof typeof timeObj] : ':'}
          </H1>
          {text && (
            <StringXSmall className="!text-white/40">{t(text)}</StringXSmall>
          )}
        </div>
      ))}
    </div>
  );
};

export { Timer };
